import React, { forwardRef, ButtonHTMLAttributes } from 'react';
import { useProviderConfig } from '../provider';
import { css } from '@emotion/react';
import { IconX } from '../icons/generated';
import { button_base_css } from '../button/styles';
import { semantic_colors } from '../../foundation';
import { ButtonIcon } from '../button/ButtonIcon';

export interface CloseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** @default 16 */
  size?: number;
  /** @default semantic_colors.content.tertiary */
  color?: string;
}

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ size = 16, color = semantic_colors.content.tertiary, ...props }, ref) => {
    const { locale } = useProviderConfig();

    return (
      <button
        aria-label={locale?.accessibility.close}
        css={[
          button_base_css,
          css`
            cursor: pointer;
            padding: 0;
            border-radius: unset;
            border: none;
            background-color: transparent;
          `,
        ]}
        {...props}
        type='button'
        ref={ref}
      >
        <ButtonIcon size={size} color={color}>
          <IconX />
        </ButtonIcon>
      </button>
    );
  },
);
